var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-wrapper"},[_c('main-left'),_c('main-content')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }